function Separator() {
	return <div className="border-blue-900-20 border-1" />;
}

export default Separator;
